<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid admin-point-programs">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <h6>Point Programs</h6>
            <hr />
            <appPointPointProgramsStartWith></appPointPointProgramsStartWith>
            <appSystemMessage
              v-if="Message"
              :message="Message"
            ></appSystemMessage>
            <router-view />
          </div>
        </transition>
      </div>
    </div>
    <appFooter></appFooter>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AdminSidebar from "@/views/admin/AdminSidebar.vue";
import SystemMessage from "@/views/admin/users/pointPrograms/PointProgramsSystemMessage";
import PointProgramsStartWith from "@/views/admin/users/pointPrograms/PointProgramsStartWith.vue";
import { mapState } from "vuex";

export default {
  name: "PointPrograms",

  props: {
    activeMenuItem: String,
    activeMenu: String,
  },

  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
    appPointPointProgramsStartWith: PointProgramsStartWith,
    appSystemMessage: SystemMessage,
  },

  data() {
    return {};
  },

  computed: {
    Message() {
      return this.$store.getters["systemMessage/getMessage"];
    },
  },

  methods: {
    setActiveMenuItem: function () {
      this.$store.dispatch("adminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "usersPointPrograms",
        activeMenu: this.activeMenu ? this.activeMenu : "users",
      });
    },
  },

  created() {
    this.setActiveMenuItem();
  },
};
</script>

<style lang="scss" scoped>
.admin-point-programs {
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}
.align-right {
  text-align: right;
}

.bold-text {
  font-weight: bold;
}

.display-flex {
  display: flex;
}

.marginAll {
  margin: 10px;
}
</style>
